export enum OrderProviderExternalErrorsWidgetsNames {
  RatioByProviders = 'ratio_by_providers',
  ReasonsByPeriod = 'reasons_by_period',
  RatioByGateways = 'ratio_by_gateways',
  RatioByReasons = 'ratio_by_reasons',
}
